module.exports = __webpack_public_path__ + "media/plant.74dce8ae.webm";